// extracted by mini-css-extract-plugin
module.exports = {"footer_notification":"notification_footer_notification__3_pjD","blink":"notification_blink__31wKi"};